"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionErrorModal = PermissionErrorModal;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function PermissionErrorModal() {
  var notification = (0, _reactSdk.useHMSNotifications)(_reactSdk.HMSNotificationTypes.ERROR);
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    deviceType = _useState2[0],
    setDeviceType = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSystemError = _useState4[0],
    setIsSystemError = _useState4[1];
  (0, _react.useEffect)(function () {
    var _notification$data, _notification$data2, _notification$data3, _notification$data4, _notification$data5;
    if (!notification || ((_notification$data = notification.data) === null || _notification$data === void 0 ? void 0 : _notification$data.code) !== 3001 && ((_notification$data2 = notification.data) === null || _notification$data2 === void 0 ? void 0 : _notification$data2.code) !== 3011 || ((_notification$data3 = notification.data) === null || _notification$data3 === void 0 ? void 0 : _notification$data3.code) === 3001 && (_notification$data4 = notification.data) !== null && _notification$data4 !== void 0 && _notification$data4.message.includes("screen")) {
      return;
    }
    console.error("[".concat(notification.type, "]"), notification);
    var errorMessage = (_notification$data5 = notification.data) === null || _notification$data5 === void 0 ? void 0 : _notification$data5.message;
    var hasAudio = errorMessage.includes("audio");
    var hasVideo = errorMessage.includes("video");
    var hasScreen = errorMessage.includes("screen");
    if (hasAudio && hasVideo) {
      setDeviceType("Camera and Microphone");
    } else if (hasAudio) {
      setDeviceType("Microphone");
    } else if (hasVideo) {
      setDeviceType("Camera");
    } else if (hasScreen) {
      setDeviceType("Screenshare");
    }
    setIsSystemError(notification.data.code === 3011);
  }, [notification]);
  return deviceType ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    open: true,
    onOpenChange: function onOpenChange(value) {
      if (!value) {
        setDeviceType("");
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Portal, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Overlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Content, {
        css: {
          w: "min(480px, 90%)"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Title, {
          css: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid $borderDefault",
            pb: "$8"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
            css: {
              fontWeight: "$semiBold"
            },
            children: [deviceType, " permissions are blocked"]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.DefaultClose, {
            "data-testid": "dialoge_cross_icon",
            css: {
              alignSelf: "start"
            }
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
          variant: "md",
          css: {
            py: "$10"
          },
          children: ["Access to ", deviceType, " is required.\xA0", isSystemError ? "Enable permissions for ".concat(deviceType, " from sytem settings") : "Enable permissions for ".concat(deviceType, " from address bar or browser settings")]
        })]
      })]
    })
  }) : null;
}